import { connect } from 'react-redux';
import { array, func } from 'prop-types';

import { DesktopAndTablet } from '../../../utils/responsiveQueries';
import { ReactComponent as GuidesIcon } from '../../../styles/icon/menu/guides.svg';
import { loadGuideContent } from '../../../redux/reducers/ghost';
import GuidePage from './GuidePage';
import docs from '../CombinedDocs.module.scss';

const mapStateToProps = (state) => ({
  ghostGuidePages: state.ghost.guidePages,
});
const mapDispatchToProps = {
  loadGuideContent
};

GuideNavigation.propTypes = {
  ghostGuidePages: array,
  loadGuideContent: func,
  preventClosingMenu: func
};

GuideNavigation.defaultProps = {
  ghostGuidePages: []
}

function GuideNavigation(props) {
  const { ghostGuidePages, loadGuideContent, preventClosingMenu } = props;

  if (!ghostGuidePages.length) return null;

  return (
    <div className={docs.docs__block}>
      <DesktopAndTablet>
        <div className={docs.docs__title_wrapper}>
          <span><GuidesIcon /></span>
          <h4 className={docs.docs__menu_title}>Guides</h4>
        </div>
      </DesktopAndTablet>
      <div className={docs.docs__list}>
        {!!ghostGuidePages.length && (
          ghostGuidePages.map((c, i) => (
            <GuidePage
              key={i}
              data={c}
              loadGuideContent={loadGuideContent}
              preventClosingMenu={preventClosingMenu}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GuideNavigation);
